import { useMemo } from "react";

export function useEventosOptions({ platos = [], vinos = [], habitaciones = [] }) {
    const platoOptions = useMemo(
        () => (platos || []).map((p) => ({ value: p.id, label: p.nombre })),
        [platos]
    );

    const vinoOptions = useMemo(
        () => (vinos || []).map((v) => ({ value: v.id, label: v.nombre })),
        [vinos]
    );

    const habitacionOptions = useMemo(() => {
        return (habitaciones || [])
            .map((h) => ({
                value: h.id,
                label: h.nombre || h.numero,
            }))
            .sort((a, b) => String(a.label).localeCompare(String(b.label)));
    }, [habitaciones]);

    return { platoOptions, vinoOptions, habitacionOptions };
}
